import * as React from 'react'
import { Space, Select, Typography, Input } from 'antd';
import { MainProperties } from './MainCSoftAccess';
const { Text } = Typography;
const { Option } = Select;
declare var $: any

interface IProps {
  filesIris:         Array<[string, string]>
  filesPdv:          Array<[string, string]>
  mainProperties:    MainProperties
  setMainProperties: React.Dispatch<React.SetStateAction<MainProperties>>
}

export default function CMainProperties(props: IProps){

  return (
    <div>
      <Space style={{width: '100%'}} direction="vertical">
        <div className='div-text-input'>
          <Text className='text-before-input'>Fichier Iris</Text>
          <Select
              id               = "file_iris_id"
              style            = {{borderRadius: '4px'}}
              showSearch
              optionFilterProp = "label"
              value            = {props.mainProperties.file_iris_id}
              filterOption     = {(input, option) =>
                (option?.label?.toString() ?? '').toLowerCase().includes(input.toLowerCase())
              }
              onChange         = {(selectedFile) => {
                props.setMainProperties({
                  ...props.mainProperties,
                  file_iris_id: selectedFile
                })
              }}
          >
          {props.filesIris.map(([value, label]) => (
              <Option key={value} value={value} label={label}>
                {label}
              </Option>
          ))}
          </Select>
        </div>
        <div className="div-text-input">
          <Text className='text-before-input'>Nom</Text>
          <Input
              id       = "name"
              style    = {{borderRadius: '4px'}}
              value    = {props.mainProperties.name}
              onChange = {(e) => {
                props.setMainProperties({
                  ...props.mainProperties,
                  name: e.target.value
                })
              }}
          />
        </div>
        <div className="div-text-input">
          <Text className='text-before-input'>Nom du réseau principal</Text>
          <Input
              id          = "mainnetwork_name"
              style       = {{borderRadius: '4px'}}
              value       = {props.mainProperties.mainnetwork_name}
              placeholder = "Si vide, le nom de l'accès sera utilisé"
              onChange    = {(e) => {
                props.setMainProperties({
                  ...props.mainProperties,
                  mainnetwork_name: e.target.value
                })
              }}
          />
        </div>
        <div className="div-text-input">
          <Text className='text-before-input'>Lien méthodologie et hypothèses</Text>
          <Input
              id       = "link"
              style    = {{borderRadius: '4px'}}
              value    = {props.mainProperties.link}
              onChange = {(e) => {
                props.setMainProperties({
                  ...props.mainProperties,
                  link: e.target.value
                })
              }}
          />
        </div>
        <div className="div-text-input">
          <Text className='text-before-input'>Unité</Text>
          <Input
              id       = "unit"
              style    = {{borderRadius: '4px'}}
              value    = {props.mainProperties.unit}
              onChange = {(e) => {
                props.setMainProperties({
                  ...props.mainProperties,
                  unit: e.target.value
                })
              }}
          />
        </div>
        <div className="div-text-input">
          <Text className='text-before-input'>Nom potentiel</Text>
          <Input
              id       = "affichage_nom_potentiel"
              style    = {{borderRadius: '4px'}}
              value    = {props.mainProperties.affichage.nom_potentiel}
              onChange = {(e) => {
                props.setMainProperties({
                  ...props.mainProperties,
                  affichage: {
                    ...props.mainProperties.affichage,
                    nom_potentiel: e.target.value
                  }
                })
              }}
          />
        </div>
        <div className="div-text-input">
          <Text className='text-before-input'>Nom potentiel accessible</Text>
          <Input
              id       = "affichage_nom_potentiel_accessible"
              style    = {{borderRadius: '4px'}}
              value    = {props.mainProperties.affichage.nom_potentiel_accessible}
              onChange = {(e) => {
                props.setMainProperties({
                  ...props.mainProperties,
                  affichage: {
                    ...props.mainProperties.affichage,
                    nom_potentiel_accessible: e.target.value
                  }
                })
              }}
          />
        </div>
        <div className="div-text-input">
          <Text className='text-before-input'>Nom vente</Text>
          <Input
              id       = "affichage_nom_vente"
              style    = {{borderRadius: '4px'}}
              value    = {props.mainProperties.affichage.nom_vente}
              onChange = {(e) => {
                props.setMainProperties({
                  ...props.mainProperties,
                  affichage: {
                    ...props.mainProperties.affichage,
                    nom_vente: e.target.value
                  }
                })
              }}
          />
        </div>
      </Space>
    </div>
    )    
}
